import { render } from "./BancoHorasTipoEditPage.vue?vue&type=template&id=560c98ae"
import script from "./BancoHorasTipoEditPage.vue?vue&type=script&lang=js"
export * from "./BancoHorasTipoEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__